function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_69859",
  "data-name": "Group 69859",
  transform: "translate(-1576 -757)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_149738",
  "data-name": "Rectangle 149738",
  width: 56,
  height: 26,
  rx: 2,
  transform: "translate(1576 757)",
  fill: "#6ce348"
}), /*#__PURE__*/React.createElement("text", {
  id: "NEW",
  transform: "translate(1587 777)",
  fill: "#fff",
  fontSize: 16,
  fontFamily: "DIN-Medium, DIN",
  fontWeight: 500
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "NEW")));

var SvgBedges1 = function SvgBedges1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 26,
    viewBox: "0 0 56 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBedges1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bedges1.09c2fee3.svg";
export { ForwardRef as ReactComponent };